import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { withSagas } from 'decorators/Sagas';
import { decorateWith } from 'helpers/decorator';
import { msas } from 'redux/saga/entities/bound';
import { selectMsaId } from 'redux/modules/features/homepage';
import { msaById } from 'redux/saga/selectors/msas';
import { LocationInputContainer } from 'components/LocationInput/LocationInputContainer';
import { loadSaga, watchSaga, changeLocation } from './location-selector.saga';
var messages = defineMessages({
  locationLeadIn: {
    id: 'location-selector.label',
    defaultMessage: 'I’m in'
  },
  locationPlaceholder: {
    id: 'location-selector.placeholder',
    defaultMessage: ' enter city name'
  }
});
export var LocationSelectorUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LocationSelectorUnwrapped, _PureComponent);

  function LocationSelectorUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LocationSelectorUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LocationSelectorUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleLocationChange = _this.handleLocationChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LocationSelectorUnwrapped, [{
    key: "handleLocationChange",
    value: function handleLocationChange(loc) {
      if (loc) {
        var lat = loc.lat,
            lon = loc.lon;
        this.props.onChangeLocation(lat, lon);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          locationName = _this$props.locationName,
          intl = _this$props.intl;
      return React.createElement(LocationInputContainer, {
        initialValue: locationName,
        inputAttributes: {
          placeholder: intl.formatMessage(messages.locationPlaceholder)
        },
        label: label || intl.formatMessage(messages.locationLeadIn),
        onChange: this.handleLocationChange,
        style: "underlined"
      });
    }
  }]);

  return LocationSelectorUnwrapped;
}(PureComponent);
LocationSelectorUnwrapped.propTypes = {
  label: PropTypes.string,
  locationName: PropTypes.string,
  onChangeLocation: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};
export var mapStateToProps = function mapStateToProps(state) {
  var msa = msaById(msas.data(state), selectMsaId(state)) || {};
  return {
    locationName: msa.city || msa.name || ''
  };
};
export var mapDispatchToProps = {
  onChangeLocation: changeLocation
};
export var LocationSelector = decorateWith(injectIntl, withSagas({
  load: loadSaga,
  watch: watchSaga
}), connect(mapStateToProps, mapDispatchToProps))(LocationSelectorUnwrapped);